export const CHANNEL_SIDEBAR_TAB = {
  HEADING: {
    key: 'HEADING',
    value: 'Channels'
  },
  INFORMATION_TOOLTIP: {
    key: 'INFORMATION_TOOLTIP',
    value: 'Channel ID for Integration'
  },
  COPY_CHANNEL_ID_TOOLTIP: {
    key: 'COPY_CHANNEL_ID_TOOLTIP',
    value: 'Copy Channel ID for Integration'
  },
  COPY_SUCCESSFUL: {
    key: 'COPY_SUCCESSFUL',
    value: 'Channel Id copied to clipboard'
  },
  COPY_FAILURE: {
    key: 'COPY_FAILURE',
    value: 'Failed to copy'
  },
  DOCUMENT: {
    key: 'DOCUMENT',
    value: 'Document'
  },
  EMAIL: {
    key: 'EMAIL',
    value: 'Email'
  },
  SHORT_MESSAGE: {
    key: 'SHORT_MESSAGE',
    value: 'Message'
  },
  CREATE_NEW_TEMPLATE_TOOLTIP: {
    key: 'CREATE_NEW_TEMPLATE_TOOLTIP',
    value: 'Create new {{type}} template'
  },
  LINK_EXISTING_TEMPLATE_TOOLTIP: {
    key: 'LINK_EXISTING_TEMPLATE_TOOLTIP',
    value: 'Link to an already existing {{type}} template'
  },
  CANCEL_LINK_BUTTON: {
    key: 'CANCEL_LINK_BUTTON',
    value: 'Cancel'
  },
  SELECT_A_DESIGN_TO_LINK: {
    key: 'SELECT_A_DESIGN_TO_LINK',
    value: 'Select a Design to link'
  },
  SEARCH_TEMPLATE_BY_NAME: {
    key: 'SEARCH_TEMPLATE_BY_NAME',
    value: 'Search design by name'
  },
  LINKING_SELECTED_TEMPLATE: {
    key: 'LINKING_SELECTED_TEMPLATE',
    value: 'Linking'
  },
  LINK_SELECTED_TEMPLATE: {
    key: 'LINK_SELECTED_TEMPLATE',
    value: 'Link'
  },
  DESIGN_ALREADY_LINKED_VALIDATION: {
    key: 'DESIGN_ALREADY_LINKED_VALIDATION',
    value: 'Sorry this design is already linked to another channel, Would you like to reassign to this channel instead?'
  },
  LINK_SUCCESS_MESSAGE: {
    key: 'LINK_SUCCESS_MESSAGE',
    value: 'Successfully linked {{targetType}} template to {{currentType}}'
  },
  LINK_ERROR_MESSAGE: {
    key: 'LINK_ERROR_MESSAGE',
    value: 'Unable to link template, Please try after some time'
  },
  DELETE_LINK_SUCCESS_MESSAGE: {
    key: 'DELETE_LINK_SUCCESS_MESSAGE',
    value: 'Successfully removed the linked template!'
  },
  DELETE_LINK_ERROR_MESSAGE: {
    key: 'DELETE_LINK_ERROR_MESSAGE',
    value: 'Failed to remove the template. Please try again!'
  },
  CHANNEL_DETAILS_FETCH_ERROR: {
    key: 'CHANNEL_DETAILS_FETCH_ERROR',
    value: 'Unable to fetch the channel details for the design!!'
  },
  ASSIGN_LANGUAGE_TOOLTIP:{
    key: 'ASSIGN_LANGUAGE_TOOLTIP',
    value: 'Assign language'
  },
  BULK_GENERATE:{
    key: 'BULK_GENERATE',
    value:'BULK GENERATE'
  },
  DOWNLOAD_REQUEST_SAMPLE:{
    key: 'DOWNLOAD_REQUEST_SAMPLE',
    value: 'DOWNLOAD REQUEST SAMPLE'
  },
  UPLOAD_FILE:{
    key: 'UPLOAD_FILE',
    value: 'UPLOAD FILE'
  },
  UPLOAD_SUCCESS_MESSAGE:{
    key: 'UPLOAD_SUCCESS_MESSAGE',
    value: 'Your request has been successfully submitted. Please go to Transactions -> Smart Batch Studio to check the status or download the files'
  },
  UPLOAD_FAILURE_MESSAGE:{
    key: 'UPLOAD_FAILURE_MESSAGE',
    value: 'Error in submitting batch request'
  },
  INVALID_ENV:{
    key: 'INVALID_ENV',
    value: 'Please provide a valid environment value'
  },
  INVALID_FILE: {
    key: 'INVALID_FILE',
    value: 'Please upload a valid file'
  }

}

export const FILTER_PANEL = {
  CHOOSE_ENVIRONMENT: {
    key: 'CHOOSE_ENVIRONMENT',
    value: 'Choose Environment'
  },
  FILE_FORMAT: {
    key: 'FILE_FORMAT',
    value: 'File Format'
  },
  DOWNLOAD_REQUEST_SAMPLE: {
    key: 'DOWNLOAD_REQUEST_SAMPLE',
    value: 'DOWNLOAD REQUEST SAMPLE'
  },
  WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD: {
    key: 'WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD',
    value: 'This design contains some nested tables. Please try providing data with JSON / XML formats instead.'
  },
  FAILURE_MESSAGE:{
    key: 'FAILURE MESSAGE',
    value: 'Please try again later'
  }
}